export default __webpack_public_path__ + "static/media/logo.f3287bb9.png";